import React from 'react';
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from '@mui/material';

import DateFnsAdapter from '@date-io/date-fns';
import EmptyPlaceholder from 'shared/components/EmptyPlaceholder';
import { AppPrimaryButton } from 'shared/components/AppComponents';
import { useNavigate } from 'react-router-dom';
import { BaseApplicationState } from 'state/baseapplication/Reducer';
import { useSelector } from 'react-redux';

const dateFns = new DateFnsAdapter();

interface IImportHistory {
  aiSystemID: string;
  importedDate: string;
  modelName: string;
  status: string;
}

interface ImportHistoryCardProps {
  importHistory: IImportHistory[];
  isLoading?: boolean;
}

const ImportHistoryCard = ({
  importHistory,
  isLoading = false,
}: ImportHistoryCardProps): React.ReactElement => {
  const navigation = useNavigate();
  const { orgACLConfig }: BaseApplicationState = useSelector(
    (state: any) => state.baseAppState
  );
  return (
    <>
      {isLoading && (
        <Box className="empty-content">
          <CircularProgress />
        </Box>
      )}

      {!isLoading && importHistory.length > 0 && (
        <Box className="table-system-record">
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table
              stickyHeader
              sx={{ minWidth: 650 }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Model Name</TableCell>
                  <TableCell align="left">Imported Date</TableCell>
                  <TableCell align="left">Status</TableCell>
                  <TableCell align="left">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {importHistory.map((row, index) => (
                  <TableRow
                    key={row.aiSystemID || index}
                    sx={{
                      '&:last-child td, &:last-child th': {
                        border: 0,
                      },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {row.modelName}
                    </TableCell>
                    <TableCell align="left" className="word-break">
                      {row.importedDate
                        ? dateFns.date(row.importedDate).toDateString()
                        : '-'}
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={row.status}
                        size="small"
                        variant="outlined"
                        sx={{ background: '#828282', color: '#f9fafb' }}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {orgACLConfig.aiInventory?.includes(
                        'aiInventory.discoveryAI.huggingFace.viewInventory'
                      ) && (
                        <AppPrimaryButton
                          title="View in Inventory"
                          isLoading={false}
                          disabled={false}
                          className="primary-light-fill btn-extra-small"
                          onClick={() => {
                            navigation(`/ai-systems/records/${row.aiSystemID}`);
                          }}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      {!isLoading && importHistory.length === 0 && (
        <Box className="app-plain-card empty-content">
          <EmptyPlaceholder
            icon={
              <img
                color="gray"
                width={50}
                src="/images/icons/ic_system.svg"
                alt="No imports"
              />
            }
            title="No models imported yet from this connection"
          />
        </Box>
      )}
    </>
  );
};
export default ImportHistoryCard;
